import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { StatusSplitEnum, TypeCodeEnum } from '@wlp/ui-px-split';
import { LoadingService } from '../../../../../../../../core/layout/services/loading.service';
import { UserInfoProfile, UserInfoService } from '@wlp/ui-bs-login';
import { ModalController, NavController } from '@ionic/angular';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { ModalSplitDetailsComponent } from '../../../../../modals/modal-split-details/modal-split-details.component';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { ModalBilletAlertCancelComponent } from '../../../../../modals/modal-billet-alert-cancel/modal-billet-alert-cancel';
import { ModalAlertComponent } from '../../../../../modals/modal-alert/modal-alert.component';
import { ModalTokenComponent } from '../../../../../modals/modal-token/modal-token.component';
import { SplitService } from '@wlp/ui-bs-split';
import { SplitDto, SplitItemDto, CancelSplitPaymentDto, ReprocessSplitPaymentDto } from '@wlp/ui-px-split';
import { ActivatedRoute } from '@angular/router';
import { MaskService } from '@wlp/ui-bs-util';

export enum TypeOperation {
  BILLET = 'BILLET',
  ON_US = 'ON_US',
  PIX = 'PIX',
  TED = 'TED',
  TEF = 'TEF',
}

@Component({
  selector: 'split-details',
  templateUrl: './split-details.page.html',
  styleUrls: ['./split-details.page.scss'],
})

export class SplitDetailsPage implements OnInit {
  @ViewChild(`btnListDate`, { static: false }) public btnListDate: ElementRef;
  public uuidSplit: string;
  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;
  userProfile: UserInfoProfile;

  public splitDetailData: SplitItemDto[];
  public splitFull: SplitDto;
  public splitItemSelected: SplitItemDto;
  public typeCode: TypeCodeEnum = TypeCodeEnum.BOM_VALOR;

  constructor(
    public loadingService: LoadingService,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService,
    protected userInfoService: UserInfoService,
    public modalController: ModalController,
    private navCtrl: NavController,
    public splitService: SplitService,
    private route: ActivatedRoute,
    private maskService: MaskService
  ) { }

  public ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);

    this.route.queryParams.subscribe(params => {
      this.uuidSplit = params['uuidSplit'];
    });

    this.loadUser();
  }

  public loadUser() {
    try {
      const userDetails = this.userInfoService.getInfoProfile();
      userDetails.then((user) => {
        this.userProfile = user;
        this.findSplitByUuid(this.uuidSplit, this.userProfile.uuidAccount, this.typeCode);
      });
    } catch (e) { }
  }

  public findSplitByUuid(uuid: string, uuidAccountPayment: string, typeCode: TypeCodeEnum) {
    this.loadingService.show();
    this.splitService.findSplitByUuid(uuid, uuidAccountPayment, typeCode).subscribe({
      next: async (split: SplitDto) => {
        this.splitFull = split;
        this.splitDetailData = split.items;
        this.loadingService.hide();
      },
      error: () => {
        this.loadingService.hide();
        this.finishSplitActionFlow('warning-circle', 'Não foi possível consultar detalhes do split')
      }
    });
  }

  public applyStatusColor(status: StatusSplitEnum) {
    switch (status) {
      case StatusSplitEnum.CREATED:
      case StatusSplitEnum.IN_PROCESS:
        return 'status blue';
      case StatusSplitEnum.PROCESS_COMPLETED:
        return 'status green';
      case StatusSplitEnum.AVAILABLE_TO_LIBERATION:
        return 'status yellow';
      case StatusSplitEnum.CANCELED:
      case StatusSplitEnum.PROCESS_COMPLETED_ERROR:
      case StatusSplitEnum.ERROR:
        return 'status red';
      case StatusSplitEnum.AWAITING_APPROVAL:
      case StatusSplitEnum.AVAILABLE:
      default:
        return 'status gray';
    }
  }

  public applyStatusText(status: StatusSplitEnum) {
    switch (status) {
      case StatusSplitEnum.CREATED:
        return 'SPLIT.AUCTION.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.CREATED';
      case StatusSplitEnum.IN_PROCESS:
        return 'SPLIT.AUCTION.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.IN_PROCESS';
      case StatusSplitEnum.AVAILABLE:
        return 'SPLIT.AUCTION.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.AVAILABLE';
      case StatusSplitEnum.PROCESS_COMPLETED:
        return 'SPLIT.AUCTION.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.PROCESS_COMPLETED';
      case StatusSplitEnum.AVAILABLE_TO_LIBERATION:
        return 'SPLIT.AUCTION.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.AVAILABLE_TO_LIBERATION';
      case StatusSplitEnum.CANCELED:
        return 'SPLIT.AUCTION.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.CANCELED';
      case StatusSplitEnum.PROCESS_COMPLETED_ERROR:
        return 'SPLIT.AUCTION.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.PROCESS_COMPLETED_ERROR';
      case StatusSplitEnum.AWAITING_APPROVAL:
        return 'SPLIT.AUCTION.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.AWAITING_APPROVAL';
      case StatusSplitEnum.ERROR:
        return 'SPLIT.AUCTION.MANAGEMENT_PAGE.TABLE.TBODY.STATUS.ERROR';
      default:
        return status;
    }
  }

  goToSplitManagmentPage() {
    this.navCtrl.navigateBack('split/auction')
  }

  public async showSplitItemDetails(splitItem: SplitItemDto) {
    const modalSplitItemDetails = await this.modalController.create({
      component: ModalSplitDetailsComponent,
      cssClass: 'modal-split-details',
      componentProps: {
        splitItem: splitItem
      },
      backdropDismiss: false,
    });

    return await modalSplitItemDetails.present();
  }

  public splitAction(actionType: string, itemSelected: SplitItemDto) {
    this.splitItemSelected = itemSelected;

    const messages = {
      cancel: 'SPLIT.AUCTION.MANAGEMENT_PAGE.MODALS.MODAL_ALERT.CANCEL_ALERT',
      reprocess: 'SPLIT.AUCTION.MANAGEMENT_PAGE.MODALS.MODAL_ALERT.REPROCESS_ALERT'
    };
    this.openConfirmationModal(messages[actionType], actionType);
  }

  public async openConfirmationModal(message: string, actionType: string) {
    const confirmationModal = await this.modalController.create({
      component: ModalBilletAlertCancelComponent,
      cssClass: 'modal-billet-alert-cancel',
      componentProps: {
        title: 'SPLIT.AUCTION.MANAGEMENT_PAGE.MODALS.MODAL_ALERT.TITLE',
        description: message,
        alert2: 'SPLIT.AUCTION.MANAGEMENT_PAGE.MODALS.MODAL_ALERT.ALERT2',
        confirmBtn: 'SPLIT.AUCTION.MANAGEMENT_PAGE.MODALS.MODAL_ALERT.CONFIRMAR_BUTTON',
        cancelBtn: 'SPLIT.AUCTION.MANAGEMENT_PAGE.MODALS.MODAL_ALERT.CANCEL_BUTTON',
        confirm: () => this.openTokenModal(actionType)
      },
      backdropDismiss: false,
    });
    await confirmationModal.present();
  }

  public async openTokenModal(actionType: string) {
    this.modalController.dismiss()

    const tokenModal = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        validationOnly: true,
        confirmation: true,
      },
      backdropDismiss: false,
    });
    tokenModal.onDidDismiss().then((data) => {
      if (data) {
        const codeAuthorization = data.role;

        this.updateSplitItem(actionType, codeAuthorization)
      }
    });
    await tokenModal.present();
  }

  public updateSplitItem(actionType: string, codeAuthorization: string) {
    switch (actionType) {
      case 'cancel':
        this.cancelSplitItem(codeAuthorization);
        break;
      case 'reprocess':
        this.reprocessSplitItem(codeAuthorization);
        break;
      default:
       ''
    }
  }

  public async finishSplitActionFlow(status: 'success' | 'warning-circle', message: string) {
    const modalRef = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status,
        message,
        confirmBtn: 'FECHAR',
        translate: true,
      },
      backdropDismiss: false,
    });
    await modalRef.present();
    await modalRef.onDidDismiss();
    this.findSplitByUuid(this.uuidSplit, this.userProfile.uuidAccount, this.typeCode);
  }

  public cancelSplitItem(codeAuthorization: string) {
    const cancelSplitPayment: CancelSplitPaymentDto = {
      uuidLot:  this.splitFull.uuid,
      uuidSplitParticipant: this.splitItemSelected.uuidSplitParticipant,
      codeAuthorization: codeAuthorization
    }

    this.splitService.cancelSplitItem(cancelSplitPayment).subscribe({
      next: async (cancelSplitPayment: CancelSplitPaymentDto) => {
        this.finishSplitActionFlow('success', 'SPLIT.AUCTION.MANAGEMENT_PAGE.MODALS.SPLIT_UPDATE_ALERT.CANCEL_ALERT.SUCESS_TEXT');
      },
      error: () => {
        this.finishSplitActionFlow('warning-circle', 'SPLIT.AUCTION.MANAGEMENT_PAGE.MODALS.SPLIT_UPDATE_ALERT.CANCEL_ALERT.ERROR_TEXT');
      }
    });
  }

  public reprocessSplitItem(codeAuthorization: string) {
    const reprocessSplitPayment: ReprocessSplitPaymentDto = {
      uuidLot:  this.splitFull.uuid,
      uuidSplitParticipant: this.splitItemSelected.uuidSplitParticipant,
      codeAuthorization: codeAuthorization
    }

    this.splitService.reprocessSplitItem(reprocessSplitPayment).subscribe({
      next: async (reprocessSplitPayment: ReprocessSplitPaymentDto) => {
        if (reprocessSplitPayment.executed) {
          this.finishSplitActionFlow('success', 'SPLIT.AUCTION.MANAGEMENT_PAGE.MODALS.SPLIT_UPDATE_ALERT.REPROCESS_ALERT.SUCCESS_TEXT');
        } else {
          this.finishSplitActionFlow('warning-circle', reprocessSplitPayment.message);
        }
      },
      error: () => {
        this.finishSplitActionFlow('warning-circle', 'SPLIT.AUCTION.MANAGEMENT_PAGE.MODALS.SPLIT_UPDATE_ALERT.REPROCESS_ALERT.ERROR_TEXT');
      }
    });
  }

  public getTypeOperation(codeOperation: string) {
    switch (codeOperation) {
      case '801':
        return TypeOperation.BILLET;
      case '901':
      case '213':
      case '805':
        return TypeOperation.ON_US;
      case '120':
      case '209':
        return TypeOperation.TED;
      case '117':
        return TypeOperation.TEF;
      case '919':
        return TypeOperation.PIX;
      default:
        return null;
    }
  }

  public formatCnpjCpf(document: string) {
    return this.maskService.formatCnpjCpf(document);
  }
}
